<template>
    <CCard class="mb-0 h-100">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title text-center">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody>
            <CTabs variant="tabs" :active-tab="view_tab">
                <CTab :title="$t('user')">
                    <UserAccountManagerTab />
                </CTab>
                <CTab :title="$t('account')" v-if="isAuthorized(['ADMIN_ROLE'])">
                    <AccountManagerTab />
                </CTab>
                <CTab :title="$t('users_manager')" v-if="isAuthorized(['ADMIN_ROLE'])">
                    <UsersManagerTab />
                </CTab>
                <CTab :title="$t('app_access')">
                    <CContainer class="section" fluid>
                        <CRow class="border-bottom">
                            <CCol md="10">
                                <h2 class="section__title my-4">{{ $t("app_access") }}</h2>
                            </CCol>
                        </CRow>
                        <CRow >
                            <CCol sm="12">
                                <p class="mt-3 text-gray">{{ $t('send_leads_by_integration_with_webserivce,_with_an_APP_key') }}.</p>
                            </CCol>
                            <CCol md="5" class="pl-5 ml-5 mt-3">
                                <JumBotronAdvance 
                                    :id="storeGlobalAppId"
                                />
                            </CCol>
                        </CRow>
                    </CContainer>
                </CTab>
            </CTabs>
        </CCardBody>
    </CCard>
    
    
</template>

<script>
import SelectCountry from "£lement/SelectCountry";
import SelectLanguage from "£lement/SelectLanguage";

import PhoneNumberInput from "~/components/PhoneNumberInput";
import JumBotronAdvance from "~/components/JumBotronAdvance";
import PaymentElementCard from "~/components/elements/PaymentElementCard";
import UsersManagerTab from "~/pages/user/components/UsersManagerTab";
import UserAccountManagerTab from "~/pages/user/components/UserAccountManagerTab";
import AccountManagerTab from "~/pages/user/components/AccountManagerTab";
import PasswordInput from "~/components/PasswordInput";
import { mapGetters } from 'vuex';
import baseMixin from '~/mixins/base.js';
import pageMixin from '~/mixins/page.js';

import { validationMixin } from "vuelidate";
import { required, numeric } from "vuelidate/lib/validators"

import { cilPencil, cilCaretBottom, cilCaretTop, cilSave } from '@coreui/icons';
export default {
    name: "ProfilePage",

    middleware: ['auth', 'page','import-stripe'],

    mixins: [ validationMixin, baseMixin, pageMixin ],

    icons:{
        cilPencil,
        cilCaretBottom,
        cilCaretTop,
        cilSave
    },
    components:{
        SelectCountry,
        SelectLanguage,
        PhoneNumberInput,
        PaymentElementCard,
        PasswordInput,
        UsersManagerTab,
        UserAccountManagerTab,
        AccountManagerTab,
        JumBotronAdvance
    },

    data() {
        return {
            forms:{
                profile:{
                    account_name:null,
                    account_surname:null,
                    account_email:null,
                    account_company:null,
                    account_postalcode:null,
                    account_city:null,
                    account_country_id:null,
                    account_address:null,
                    account_id:null,
                    account_language_id:null,
                    _loading:false
                },
                password:{
                    password:null,
                    new_password:null,
                    repeat_new_password:null
                },
                billing:{
                    payment_method:null
                }
            },
            tables:{
                invoices:{
                    fields:[
                        {
                            key: "id",
                            label: "#",
                        },
                        {
                            key: "currency",
                            label: "currency",
                        },
                        {
                            key: "period_end",
                            label: "period_end",
                        },
                        {
                            key: "period_start",
                            label: "period_start",
                        },
                        {
                            key: "status",
                            label: "status",
                        },
                        {
                            key: "subscription",
                            label: "subscription",
                        },
                        {
                            key: "total",
                            label: "total",
                        },
                    ],
                    items:[{}],
                    order:"asc",
                    rows:5,
                    page:1,
                    total_pages:1,
                    loading:false

                }
            },
            modals:{
                change_password:{
                    show:false,
                    data:{
                        password:null,
                        new_password:null
                    }
                }
            },
            collapses:{
                address_and_time:{
                    show:false
                },
                business_details:{
                    show:false
                }
            },
            edit_profile:false,
            update_billing_address:false,
            stripe:{
                instance:null,
                elements:null
            },
        }
    },
    computed:{
        ...mapGetters({
            user:"auth/user",
            public_key:"payment/public_key",
            storeGlobalAppId: "auth/appId",
        }),
        view_tab:function(){
            return parseInt(this.$route.query.view_tab)  || 0;
        },
        view_type:function(){
            return "edit";
        },

        profileUpperCase(){
            let profile = {};
            for(let key in this.forms.profile){
                profile = {
                    ...profile,
                    [key.toUpperCase()]: this.forms.profile[key]
                };
            }
            return profile;
        },

        computed_country_id:{
            get: function () {
                return parseInt(this.forms.profile.account_country_id);
            },
            set: function (newValue) {
                this.forms.profile.account_country_id = newValue.toString();
            }

        }
    },
    validations:{
        forms:{
            profile:{
                account_name:{
                    required
                },
                account_surname:{
                    required
                },
                account_email:{
                    required
                },
                account_company:{
                    required
                },
                account_postalcode:{
                    required
                },
                account_city:{
                    required
                },
                account_country_id:{
                    required
                },
                account_address:{
                    required
                },
                account_id:{
                },
                account_language_id:{
                }
            }
        }
    },
    methods: {
        getBadge (status) {
            switch (status) {
                case 'active': return 'success'
                case 'inactive': return 'secondary'
                case 'pending': return 'warning'
                case 'banned': return 'danger'
                default: 'primary'
            }
        },

        async loadForm({ form_name, data }){
            let form = this.forms[form_name];
            if(!form){
                throw { code: 422, message: this.$t("the_form_does_not_exist") };
            }

            for (const key in form) { 
                let data_find = data.find((item)=>{
                                    return item.name.toLowerCase() == key;
                                });
                form[key] = (data_find) ? data_find.value : form[key];

                if(key == "account_language_id"){
                    form[key] = parseInt(form[key]);
                }
            }

            this.forms = {
                ...this.forms,
                [form_name]:form
            }  
        },

        async formatDataForm(data){
            let list_items = [];
            for (const key in data.items) {
                if (Object.hasOwnProperty.call(data.items, key)) {
                    list_items.push(data.items[key]);
                    
                }
            }
            return list_items;
        },
        async formatDataProfileToSend(data){

            let data_format = [];
            for (const key in data) {
                if (Object.hasOwnProperty.call(data, key)) {
                    data_format.push({
                        name:key.toUpperCase(),
                        value:data[key]
                    })
                }
            }
            return data_format;
        },

        async sendFormProfile(){
            this.forms.profile._loading = true;
            this.updatePageLoading(true);
            await this.sendForm({ 
                form_name: 'profile', 
                url:'/identity.api/UpdateAccountData',
                method: 'POST', 
                formatData: this.formatDataProfileToSend
            });

            /* let user = this.profileUpperCase;
            this.$store.dispatch("auth/setLanguageUser", { user }); */

            this.forms.profile._loading = false;
            this.updatePageLoading(false);
        },

        async updateData(){
            /* await this.updateForm({
                form_name:'profile',
                url:'/identity.api/UpdateAccountData',
                formatData: this.formatDataForm
            }); */
            this.updatePageLoading(false);
        }

    },
    async mounted(){
        await this.updateData();
    },
    async created(){
        this.stripe.instance = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
        this.stripe.elements = this.stripe.instance.elements();
    },
    
}
</script>
<style scoped lang="scss">
    .personal-info{
        padding: 0;
        & .c-avatar{
            width: 7em;
            height: auto;
            position: relative;

            & .c-avatar-input{
                position: absolute !important;
                z-index: 1000;
                right: -5px;
                top: -5px;
                & .btn{
                    border-radius: 50px;
                    background-color: white;
                    & .c-avatar-label{
                        margin: 0;
                    }
                }
                
            }
        }

        @media (min-width: 576px) {
            padding: 0 2em;
        }
    }
    
    
    
</style>
